// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__M2wGC","label":"styles_label__k4R2w","icon":"styles_icon__gkFVo"};